import React from "react";
import { useTranslation } from "@coworker/locales";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import CrossIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossIconPath";
import SearchBarComponentPresentation from "./SearchBarComponentPresentation";
import { FixaSearchActions } from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";

interface SearchBarComponentProps {
  onSearchBarClick?: () => void | undefined;
  handleSearchQueryChange?: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void | undefined;
  onSearchQueryReset?: () => void | undefined;
  searchQuery?: string | undefined;
  onCloseSearchClick?: () => void | undefined;
  shouldShowCloseButton?: boolean | undefined;
  autoFocus?: boolean | undefined;
  onFocus?: () => void | undefined;
  onBlur?: () => void | undefined;
  actions?: FixaSearchActions[] | undefined;
  showScannerIsReady?: boolean | undefined;
}

const SearchBarComponent: React.FC<SearchBarComponentProps> = ({
  onSearchBarClick,
  handleSearchQueryChange,
  onSearchQueryReset,
  searchQuery,
  onCloseSearchClick,
  shouldShowCloseButton,
  autoFocus,
  onFocus,
  onBlur,
  actions,
}: SearchBarComponentProps) => {
  const { t } = useTranslation();
  if (!shouldShowCloseButton || !onCloseSearchClick) {
    return (
      <SearchBarComponentPresentation
        onClick={onSearchBarClick ?? (() => {})}
        onChange={handleSearchQueryChange ?? (() => {})}
        onClear={onSearchQueryReset ?? (() => {})}
        onFocus={onFocus ?? (() => {})}
        onBlur={onBlur ?? (() => {})}
        valueString={searchQuery ?? ""}
        translationsSearchString={t("searchBasicString")}
        autoFocus={autoFocus}
        actions={actions}
      />
    );
  }

  return (
    <SearchBarComponentPresentation
      onClick={onSearchBarClick ?? (() => {})}
      onChange={handleSearchQueryChange ?? (() => {})}
      onClear={onSearchQueryReset ?? (() => {})}
      onFocus={onFocus ?? (() => {})}
      onBlur={onBlur ?? (() => {})}
      valueString={searchQuery ?? ""}
      translationsSearchString={t("searchBasicString")}
      autoFocus={autoFocus}
      actions={actions}
      closeButtonComponent={
        <FixaButton
          onClick={() => {
            onCloseSearchClick();
          }}
          type="secondary"
          data-testid="close-button"
          iconOnly
          size="small"
          ssrIcon={CrossIconPath}
        />
      }
    />
  );
};

export default SearchBarComponent;
